import React, { useEffect, useState } from 'react';
import { Button, Center, Group, Modal, Text } from '@mantine/core';

export default function MantineConfirmModal({
  opened,
  onClose,
  title,
  onConfirm,
  doubleConfirm = false,
  bodyText,
  confirmLabel,
  cancelLabel,
  confirmColor = 'red',
}) {
  const [step, setStep] = useState(0);

  useEffect(() => {
    if (opened) {
      setStep(0);
    }
  }, [opened]);

  const handleNo = () => {
    onClose();
  };

  const handlePrimary = () => {
    if (!doubleConfirm) {
      onConfirm();
      onClose();
      return;
    }
    if (step === 0) {
      setStep(1);
      return;
    }
    onConfirm();
    onClose();
  };

  const bodyTextDisplay =
    doubleConfirm && step === 1
      ? 'Are you super-duper sure?'
      : (bodyText ?? 'Are you sure?');
  const confirmButtonLabel =
    doubleConfirm && step === 1 ? 'Yes, 100%' : (confirmLabel ?? 'Yes, I\'m sure');
  const cancelButtonLabel = cancelLabel ?? 'No';

  return (
    <Modal opened={opened} onClose={onClose} title={title} centered>
      <Center py='50px'>
        <Text fw={700}>{bodyTextDisplay}</Text>
      </Center>
      <Group grow gap='sm' w='100%' wrap='nowrap'>
        <Button fullWidth color={confirmColor} variant='filled' onClick={handlePrimary}>
          {confirmButtonLabel}
        </Button>
        <Button fullWidth variant='default' onClick={handleNo}>
          {cancelButtonLabel}
        </Button>
      </Group>
    </Modal>
  );
}
